import React, { Fragment, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams, useHistory } from 'react-router-dom';
import { Alert, Col, Table } from 'react-bootstrap';
import { addCommas } from '@persian-tools/persian-tools';
import { paramCase } from 'change-case';
import Toast from '../../components/Toast';
import { txtPage, txtRT, txtTable } from '../../utils/texts';
import { getAllCourseRunDemands, getCourseRunDemand, setCourseRunDemandsStatus } from '../store/action/CourseAction';
import Head from '../../components/Head';
import Loader from '../../components/Loader';
import { ConvertToJalali } from '../../utils';
import { Link } from 'react-router-dom';
import { Button } from 'react-bootstrap';
import Plyr from 'react-plyr';
import Hls from 'hls.js';

const CourseRunDemandsDetail = () => {
  let history = useHistory();

  const { courseRunDemandDetail, isLoading, error, status } = useSelector(state => state.courseRunDemands);
  // const permission = useSelector((state) => state.permissionSelected.data);
  const { permissions, selectedRole, selectedOrg } = useSelector(state => state.permission);

  let roleName = selectedRole.name;

  const dispatch = useDispatch();
  let { id } = useParams();

  const videoRef = useRef();
  useEffect(() => {
    const video = videoRef.current;
    if (!video) return;

    video.controls = true;
    const defaultOptions = {};

    if (video.canPlayType('application/vnd.apple.mpegurl')) {
      // This will run in safari, where HLS is supported natively
      video.src = courseRunDemandDetail?.hls_video_url;
    } else if (Hls.isSupported()) {
      // This will run in all other modern browsers
      const hls = new Hls();
      hls.loadSource(courseRunDemandDetail?.hls_video_url);
      const player = new Plyr(video, defaultOptions);
      hls.attachMedia(video);
    } else {
      console.error(
        'This is an old browser that does not support MSE https://developer.mozilla.org/en-US/docs/Web/API/Media_Source_Extensions_API'
      );
    }
  }, [courseRunDemandDetail, videoRef]);

  const handleChangeDemandStatusClick = async (id, status) => {
    function afterChangeStatus() {
      history.push('/courses');
    }

    dispatch(setCourseRunDemandsStatus(roleName, id, status, afterChangeStatus));
  };

  useEffect(() => {
    if (selectedRole) {
      roleName = paramCase(selectedRole?.name);
      if (roleName !== 'owner' && roleName !== 'course-creator') history.push('/');
      if (roleName) dispatch(getCourseRunDemand(id, roleName));
    }
  }, [permissions]);

  useEffect(() => {
    if (status === 'accepted') {
      Toast(txtRT.table.setAccepted, 'info');
      dispatch(getCourseRunDemand(id, roleName));
    }
    if (status === 'rejected') {
      Toast(txtRT.table.setRejected, 'info');
      dispatch(getCourseRunDemand(id, roleName));
    }
  }, [status]);

  return (
    <Fragment>
      <Head title="جزئیات دوره " />
      {courseRunDemandDetail ? (
        <>
          {courseRunDemandDetail?.status === 1 && (
            <Alert className="d-flex justify-content-between align-items-center" variant={'info'}>
              <p className="h4">این دوره نیاز به تائید یا رد دارد</p>
              <div>
                <span
                  className={`btn btn-success`}
                  rel="noopener noreferrer"
                  onClick={() => handleChangeDemandStatusClick(courseRunDemandDetail.id, 'accept')}
                >
                  تائید
                  <i className="fas fa-check ml-1"></i>
                </span>
                <span
                  className={`btn btn-danger ml-3`}
                  rel="noopener noreferrer"
                  onClick={() => handleChangeDemandStatusClick(courseRunDemandDetail.id, 'reject')}
                >
                  رد
                  <i className="fas fa-times ml-1"></i>
                </span>
              </div>
            </Alert>
          )}
          {courseRunDemandDetail?.status == 2 && (
            <Alert className="d-flex justify-content-between align-items-center" variant={'success'}>
              <span>این دوره تائید شده است</span>
            </Alert>
          )}
          {courseRunDemandDetail?.status == 3 && (
            <Alert className="d-flex justify-content-between align-items-center" variant={'danger'}>
              <span>این دوره رد شده است</span>
            </Alert>
          )}
          <div className="kt-portlet p-3">
            <div className="kt-portlet__body">
              <div className="d-flex">
                <AtrName>عنوان:</AtrName>
                <AtrContent>{courseRunDemandDetail?.title}</AtrContent>
              </div>
              <div className="d-block d-lg-flex mt-4">
                <Col xs={12} lg={6} className="d-flex">
                  <AtrName>تاریخ شروع:</AtrName>
                  <AtrContent>{ConvertToJalali(courseRunDemandDetail?.start)}</AtrContent>
                </Col>
                <Col xs={12} lg={6} className="d-flex">
                  <AtrName>تاریخ پایان:</AtrName>
                  <AtrContent>{ConvertToJalali(courseRunDemandDetail?.end)}</AtrContent>
                </Col>
              </div>
              <div className="d-block d-lg-flex mt-4">
                <Col xs={12} lg={6} className="d-flex">
                  <AtrName>قیمت:</AtrName>
                  <AtrContent>{addCommas(courseRunDemandDetail?.price)} تومان </AtrContent>
                </Col>
                <Col xs={12} lg={6} className="d-flex">
                  <AtrName>زبان دوره:</AtrName>
                  <AtrContent>{courseRunDemandDetail?.language.name}</AtrContent>
                </Col>
              </div>
              <div className="d-block d-lg-flex mt-4">
                <Col xs={12} lg={6} className="d-flex">
                  <AtrName>سطح دوره:</AtrName>
                  <AtrContent>{courseRunDemandDetail?.level_type.name}</AtrContent>
                </Col>
                <Col xs={12} lg={6} className="d-flex">
                  <AtrName>شماره دوره:</AtrName>
                  <AtrContent>{courseRunDemandDetail?.number}</AtrContent>
                </Col>
              </div>
              <div className="d-block d-lg-flex mt-4">
                <Col xs={12} lg={6} className="d-flex">
                  <AtrName>سازمان:</AtrName>
                  <AtrContent>{courseRunDemandDetail?.organization.name}</AtrContent>
                </Col>
                <Col xs={12} lg={6} className="d-flex">
                  <AtrName>توضیحات کوتاه:</AtrName>
                  <AtrContent>{courseRunDemandDetail?.short_description}</AtrContent>
                </Col>
              </div>
              <div className="d-block d-lg-flex mt-4">
                <Col xs={12} lg={6} className="d-flex">
                  {courseRunDemandDetail?.tags?.length ? (
                    <>
                      <AtrName>تگ ها:</AtrName>
                      <AtrContent>{courseRunDemandDetail?.tags.map(tag => tag + '، ')}</AtrContent>
                    </>
                  ) : null}
                </Col>
                <Col xs={12} lg={6} className="d-flex">
                  <AtrName>توضیحات کامل:</AtrName>
                  <AtrContent className="h5">{courseRunDemandDetail?.full_description}</AtrContent>
                </Col>
              </div>
              <div className="d-block d-lg-flex mt-5 ">
                <Col xs={12} lg={6} className="d-flex flex-column">
                  <AtrName>تصویر:</AtrName>
                  <img
                    src={courseRunDemandDetail.image}
                    style={{
                      height: '300px',
                      width: '400px',
                      backgroundRepeat: 'no-repeat',
                      backgroundSize: 'cover',
                      backgroundPosition: 'center center',
                    }}
                  />
                </Col>
                <Col xs={12} lg={6} className="d-flex flex-column">
                  {courseRunDemandDetail?.hls_video_url && (
                    <>
                      <AtrName>ویدیو:</AtrName>
                      <video width="400px" height="300px" controls ref={videoRef} />
                    </>
                  )}
                </Col>
              </div>
              <div className="d-block d-lg-flex mt-5">
                {!!courseRunDemandDetail.prerequisites.length && (
                  <Col xs={12} lg={6}>
                    <>
                      <AtrName>پیش نیاز ها:</AtrName>
                      <Table bordered striped hover variant="light">
                        <thead>
                          <tr>
                            <th className="font-weight-bold" style={{ width: '5%' }}>
                              {txtTable.counter}
                            </th>
                            <th className="font-weight-bold">{txtTable.caption}</th>
                          </tr>
                        </thead>
                        <tbody>
                          {courseRunDemandDetail?.prerequisites?.map((prerequisite, index) => (
                            <tr key={index}>
                              <td>{index + 1}</td>
                              <td>{prerequisite.key}</td>
                            </tr>
                          ))}
                        </tbody>
                      </Table>
                    </>
                  </Col>
                )}
                {courseRunDemandDetail?.expected_learning_items_list && (
                  <Col xs={12} lg={6}>
                    <>
                      <AtrName>یادگیری ها:</AtrName>
                      <Table bordered striped hover variant="light">
                        <thead>
                          <tr>
                            <th className="font-weight-bold" style={{ width: '5%' }}>
                              {txtTable.counter}
                            </th>
                            <th className="font-weight-bold">{txtTable.caption}</th>
                          </tr>
                        </thead>
                        <tbody>
                          {courseRunDemandDetail?.expected_learning_items_list?.map((item, index) => (
                            <tr key={index}>
                              <td>{index + 1}</td>
                              <td>{item.value}</td>
                            </tr>
                          ))}
                        </tbody>
                      </Table>
                    </>
                  </Col>
                )}
              </div>
              {courseRunDemandDetail?.coupon_demands && (
                <div className="d-block mt-5">
                  <>
                    <AtrName>کدهای تخفیف درخواستی:</AtrName>
                    <Table bordered striped hover variant="light">
                      <thead>
                        <tr>
                          <th className="font-weight-bold" style={{ width: '5%' }}>
                            {txtTable.counter}
                          </th>
                          <th className="font-weight-bold">مقدار</th>
                          <th className="font-weight-bold">کد</th>
                          <th className="font-weight-bold">تعداد</th>
                        </tr>
                      </thead>
                      <tbody>
                        {courseRunDemandDetail?.coupon_demands?.map((coupon, index) => (
                          <tr key={coupon.id}>
                            <td>{index + 1}</td>
                            <td>
                              {coupon.value}
                              {coupon.kind == 1 ? '%' : 'تومان'}
                            </td>
                            <td>{coupon.code}</td>
                            <td>{coupon.count}</td>
                          </tr>
                        ))}
                      </tbody>
                    </Table>
                  </>
                </div>
              )}
            </div>
          </div>
        </>
      ) : (
        <div className="kt-portlet p-3">
          <div className="kt-portlet__body">
            <div className="rounded bg-light my-3" style={{ minWidth: '60%' }}>
              <p className="h4 text-center px-2 py-5 mb-0">{txtPage.CourseRunDemands.notCourses.description}</p>
              <Link to="/courses/new">
                <Button>ایجاد دوره</Button>
              </Link>
            </div>
          </div>
        </div>
      )}
      <Loader visible={isLoading} />
    </Fragment>
  );
};

const AtrName = ({ children }) => <p className="font-weight-bold text-lg mr-2 h4">{children}</p>;
const AtrContent = props => (
  <p style={{ color: 'rgba(33, 37, 41, 0.51)' }} className="h4" {...props}>
    {props.children}
  </p>
);

export default CourseRunDemandsDetail;
